const { dateOnlyInBangkok } = require('./contractDates')
const inactive = new Set(['rejected', 'cancelled', 'canceled', 'ยกเลิก', 'ended'])
function findOverlap(summary, start, end) {
  if (!summary || !start || !end || end < start) return null
  return (summary.contracts || [summary]).find(contract => {
    if (inactive.has(contract.status)) return false
    const last = contract.termination_date
      ? (() => { const d = new Date(`${dateOnlyInBangkok(contract.termination_date)}T00:00:00Z`); d.setUTCDate(d.getUTCDate()-1); return d.toISOString().slice(0,10) })()
      : dateOnlyInBangkok(contract.end_date)
    return dateOnlyInBangkok(contract.start_date) <= end && last >= start
  }) || null
}
function describeContract(contract, today = dateOnlyInBangkok(new Date())) {
  if (!contract) return { label: 'ยังไม่มีสัญญา', tone: 'none' }
  const action = contract.contract_type === 'ต่อสัญญา' ? 'ต่อสัญญาแล้ว' : 'สร้างสัญญาแล้ว'
  const states = {
    draft: 'ฉบับร่าง', pending: 'รอพนักงานลงนาม', signed: 'รอพยาน 1 ลงนาม',
    witness1_signed: 'รอพยาน 2 ลงนาม', approved: 'รอนายกลงนาม',
    completed: 'ลงนามครบ', ended: 'สิ้นสุดก่อนกำหนด',
    rejected: 'ไม่อนุมัติ', cancelled: 'ยกเลิกแล้ว', canceled: 'ยกเลิกแล้ว', 'ยกเลิก': 'ยกเลิกแล้ว'
  }
  let state = states[contract.status] || `สถานะ ${contract.status || 'ไม่ทราบ'}`
  if (contract.status === 'completed') {
    if (contract.termination_date && dateOnlyInBangkok(contract.termination_date) <= today) state += ' · สิ้นสุดก่อนกำหนด'
    else if (dateOnlyInBangkok(contract.end_date) < today) state += ' · หมดอายุ'
    else if (dateOnlyInBangkok(contract.start_date) > today) state += ' · ยังไม่เริ่มมีผล'
  }
  return { label: `${action} · ${state}`, tone: inactive.has(contract.status) ? 'inactive' : contract.contract_type === 'ต่อสัญญา' ? 'renewed' : 'created' }
}
function thaiDate(value) {
  const date = dateOnlyInBangkok(value)
  if (!date) return '-'
  const [y,m,d] = date.split('-').map(Number)
  return `${String(d).padStart(2,'0')}/${String(m).padStart(2,'0')}/${y+543}`
}
module.exports = { findOverlap, describeContract, thaiDate }
